/**
 * Created by vhe on 5/12/2017.
 */
'use strict';
import _ from 'lodash';
import angular from 'angular';
var PaymentCreditCardController = /** @class */ (function () {
    /* @ngInject*/
    function PaymentCreditCardController($log, $scope, $timeout, $state, $q, $rootScope, CreditCardService, Util, CartService, AddressService, $filter, SettingsService, Auth, $window, FocusOnService) {
        this.expiredCard = false;
        this.oldPaymentMethod = null;
        this.updatingPricing = null;
        this.uiRouterState = null;
        this.loggedInUser = {};
        var self = this;
        self.$scope = $scope;
        self.$timeout = $timeout;
        self.$state = $state;
        self.$q = $q;
        self.CreditCardService = CreditCardService;
        self.CartService = CartService;
        self.AddressService = AddressService;
        self.SettingsService = SettingsService;
        self.Util = Util;
        self.Auth = Auth;
        self._$rootScope = $rootScope;
        this.FocusOnService = FocusOnService;
        // flag
        self.isNewCreditCard = false;
        self.isNewBillingAddress = true;
        self.disableRevieworder = false;
        // model
        self.postPaymentModel = {
            'paymentMethodType': null,
            'verificationCode': null,
            'paymentMethodId': null
        };
        self.errors = {
            pageErrorType: '',
            pageErrors: '',
            havePageErrors: false
        };
        self.cvvPattern = '^[0-9]{3}$';
        self.creditCards = []; // all credit cards associated with current account
        self.creditCard = {
            'billingAddress': self.createEmptyAddress(),
        }; // Credit Card model of the ccForm
        self.creditCardTypeModel = [
            { typeId: 0, name: 'Visa', typeName: 'visa', aresName: 'Visa' },
            { typeId: 1, name: 'Mastercard', typeName: 'mastercard', aresName: 'MC' },
            { typeId: 2, name: 'American Express', typeName: 'amex', aresName: 'Amex' },
            { typeId: 3, name: 'Discover', typeName: 'discover', aresName: 'Discover' }
        ];
        self.paymentTypes = [
            'CreditCard',
            'Terms',
            'COD',
            'Prepaid'
        ];
        self.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        self.years = [];
        (function () {
            var currentData = new Date;
            var currentYear = currentData.getFullYear();
            for (var i = 0; i < 10; i++) {
                self.years.push((currentYear + i).toString());
            }
        })();
        self.allowedPaymentTypes = [
            { method: 'Credit Card', allowed: true },
            { method: 'Terms', allowed: false },
            { method: 'COD', allowed: false },
            { method: 'Prepaid', allowed: false }
        ];
        // Check User is Logged in or not
        self.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.loggedInUser = loggedInUser;
            }
            else {
                $window.location = '/auth/ares';
            }
        });
        self.addresses = [];
        self.selectedPaymentType = 'Credit Card';
    }
    // End of Constructor
    PaymentCreditCardController.prototype.bannerMessage = function (message) {
        this.errors.pageErrorType = 'warning';
        this.errors.pageErrors = message;
        this.errors.havePageErrors = true;
        this.showAlert = true;
    };
    PaymentCreditCardController.prototype.closeAlertMessage = function () {
        this.showAlert = false;
    };
    PaymentCreditCardController.prototype.setNewCreditCardForm = function () {
        this.isNewCreditCard = true;
        this.clearCcForm();
    };
    PaymentCreditCardController.prototype.setNewBillingForm = function () {
        this.isNewBillingAddress = true;
        this.isNameOnCardDisable = false;
        this.isSameAsShipping = false;
        this.selectbillingAddressInfo = '';
        this.existingBillingAddress = null;
        if (this.creditCard.billingAddress != null && this.creditCard.billingAddress.recipientName != undefined && this.creditCard.billingAddress.recipientName != null) {
            this.creditCard.nameOnCard = '';
        }
        this.creditCard.billingAddress = this.createEmptyAddress();
    };
    PaymentCreditCardController.prototype.getPaymentInformation = function () {
        var _this = this;
        this.CreditCardService.getCreditCards().then(function (data) {
            if (data.length) {
                if (!_(data).some(function (p) { return p.paymentType === 'CreditCard' && p.isDefaultPayment; })) {
                    var mostRecentlyUsedCard = _(data).filter(function (p) { return p.paymentType === 'CreditCard'; }).orderBy(function (p) { return new Date(p.dateLastUsed); }).last();
                    if (mostRecentlyUsedCard)
                        mostRecentlyUsedCard.isDefaultPayment = true;
                }
                data.forEach(function (item, itemIndex) {
                    // get allowed payment type to current account
                    if (item.paymentType == 'CreditCard') {
                        _this.creditCards.push(item); // push credit card to creditCards
                        if (item.isDefaultPayment) {
                            _this.isCardDefault = true;
                            _this.existingCard = item;
                            _this.useExistingCreditCard(item);
                            _this.selectExistingCard();
                        }
                        if (itemIndex == data.length - 1 && !_this.isCardDefault) {
                            _this.existingCard = item;
                            _this.useExistingCreditCard(item);
                            _this.selectExistingCard();
                        }
                    }
                    else if (item.paymentType == 'Terms') {
                        _this.allowedPaymentTypes[1].allowed = true;
                    }
                    else if (item.paymentType == 'COD') {
                        _this.allowedPaymentTypes[2].allowed = true;
                    }
                    else if (item.paymentType == 'Prepaid') {
                        _this.allowedPaymentTypes[3].allowed = true;
                    }
                    if (item.isDefaultPayment)
                        _this.selectedPaymentType = item.paymentType == "CreditCard" ? "Credit Card" : item.paymentType;
                });
            }
        });
    };
    PaymentCreditCardController.prototype.useExistingCreditCard = function (creditCard) {
        creditCard.isDefaultPayment ? this.creditCard.isDefaultPayment = true : this.creditCard.isDefaultPayment = false;
        this.isNewCreditCard = false;
        this.isNewBillingAddress = false;
        var dateParts = creditCard.expirationDate.split('/');
        if (dateParts[1].length === 4) {
            this.expirationMonth = dateParts[0];
            this.expirationYear = dateParts[1];
        }
        else {
            this.expirationMonth = dateParts[1];
            this.expirationYear = dateParts[0];
        }
        var expirationDate = new Date(this.expirationYear + '/' + this.expirationMonth);
        var currentData = new Date;
        // make sure that a cc with an exp month the same as the current month is not invalid
        this.isCardExpired = expirationDate < currentData && expirationDate.getMonth() < currentData.getMonth();
        this.cardType = this.creditCardTypeModel[creditCard.cardType];
        this.creditCard.last4Digits = creditCard.last4Digits;
        this.creditCard.creditCardId = creditCard.creditCardId;
        this.isDefault = creditCard.isDefaultPayment;
        this.creditCard.nameOnCard = creditCard.nameOnCard;
        this.creditCard.billingAddress = angular.copy(creditCard.billingAddress);
        if (this.ccForm.ccNumber) {
            this.ccForm.ccNumber.placeholder = 'XXXX XXXX XXXX ' + this.creditCard.last4Digits;
            this.ccForm.ccNumber.$setDirty();
            this.ccForm.ccNumber.$setTouched();
        }
        if (this.ccForm.verificationCode) {
            this.creditCard.verificationCode = '';
            this.ccForm.verificationCode.$setPristine();
            this.ccForm.verificationCode.$setUntouched();
        }
        if (this.ccForm.verificationCodeNewCard) {
            this.ccForm.verificationCodeNewCard.$setPristine();
            this.ccForm.verificationCodeNewCard.$setUntouched();
        }
        this.isExpired();
        this.useExistingAddress(creditCard.billingAddress);
        // set credit card info for info-card
        this.creditCardInfo = {
            type: this.cardType.name,
            number: 'XXXX-XXXX-XXXX-' + this.creditCard.last4Digits,
            ExpDate: this.expirationMonth + '/' + this.expirationYear
        };
        if (!this.firstTimeFocused) {
            this.FocusOnService.focus('cvvInput');
            this.firstTimeFocused = true;
        }
    };
    PaymentCreditCardController.prototype.selectExistingAddress = function () {
        var self = this;
        self.isNewBillingAddress = false;
        self.addressList = [];
        self.addresses.forEach(function (item) {
            self.name = item.recipientName.split(' ');
            if (self.name.length == 1) {
                item.firstName = self.name[0];
                item.lastName = self.name[0];
            }
            else if (self.name.length > 0) {
                for (var i = 0; i < self.name.length; i++) {
                    if (i == 0) {
                        item.firstName = self.name[i];
                        item.lastName = '';
                    }
                    else {
                        item.lastName += self.name[i];
                    }
                }
            }
            self.addressList.push(item);
        });
    };
    PaymentCreditCardController.prototype.useExistinBillingAddress = function (address) {
        this.creditCard.billingAddress = address;
        this.isSameAsShipping = false;
        this.existingBillingAddress = address;
        this.creditCard.nameOnCard = address.recipientName;
        this.isNameOnCardDisable = true;
        this.selectbillingAddressInfo = {
            name: address.recipientName,
            address: "\n        " + address.line1 + " " + (address.line2 ? address.line2 : '') + "<br>\n        " + address.city + ", " + address.regionCode + "\n        " + (address.postalCode.length > 5 && address.countryCode === 'US'
                ? address.postalCode.substr(0, 5) + '-' + address.postalCode.substr(5)
                : address.postalCode) + ",\n           " + address.countryName.toLowerCase() + "\n      "
        };
    };
    PaymentCreditCardController.prototype.setDefaultPayment = function () {
        this.creditCard.isDefaultPayment = true;
    };
    PaymentCreditCardController.prototype.checkCvvPattern = function () {
        if (this.cardType) {
            if (this.cardType.typeId === 2) {
                this.cvvPattern = '^[0-9]{4}$';
            }
            else {
                this.cvvPattern = '^[0-9]{3}$';
            }
        }
    };
    PaymentCreditCardController.prototype.useExistingAddress = function (address) {
        this.existingAddress = address;
        this.isNewBillingAddress = false;
        this.creditCard.billingAddress = angular.copy(address);
        (this.creditCard.billingAddress || {}).addressId = null;
    };
    PaymentCreditCardController.prototype.$onInit = function () {
        var that = this;
        this.CartService.updateDeliveryOption();
        this.getPaymentInformation();
        this.AddressService.getAddresses()
            .then(function (response) {
            that.addresses = response.data.response.currentPage;
        }, function (response) {
            // TODO: Error Handling
        });
        // this.populateCreditCardFormDetails();
        this.uiRouterState = this.$state.current.name;
    };
    /**
     * Trigger output event to parent component
     */
    PaymentCreditCardController.prototype.selectExistingCard = function () {
        this.onSelectPayment({
            $event: {
                creditCard: this.existingCard
            }
        });
    };
    PaymentCreditCardController.prototype.populateCreditCardFormDetails = function () {
        var _this = this;
        if (this.CartService.cartData == undefined
            || this.CartService.cartData.payment == undefined
            || this.CartService.cartData.payment.paymentType != 'CreditCard') {
            return;
        }
        var creditCardDetails = this.CartService.cartData.payment;
        this.$timeout(function () {
            _this.useExistingCreditCard(creditCardDetails, _this.ccForm);
        }, 0);
    };
    PaymentCreditCardController.prototype.validateCard = function () {
        if (this.cardType) {
            if (this.cardType.typeName != this.validatorCardType || this.ccForm.ccNumber.$error.card) { // this.$scope.ccForm.ccNumber.$error.card is set by angular-payments
                this.invalidErrorMessage = 'The number you entered is not valid for the card type.';
                this.ccForm.ccNumber.$valid = false;
                this.ccForm.ccNumber.$invalid = true;
                this.ccForm.ccNumber.$error = { 'invalid': true };
            }
            else {
                this.ccForm.ccNumber.$valid = true;
                this.ccForm.ccNumber.$invalid = false;
                this.ccForm.ccNumber.$error = {};
            }
            this.checkCvvPattern();
        }
    };
    PaymentCreditCardController.prototype.isExpired = function () {
        if (this.expirationMonth != undefined && this.expirationYear != undefined) {
            var today = new Date();
            var cardDate = new Date(this.expirationYear, this.expirationMonth);
            if (cardDate < today) {
                this.expiredCard = true;
            }
            else {
                this.expiredCard = false;
            }
        }
    };
    PaymentCreditCardController.prototype.clearCcForm = function () {
        this.existingAddress = undefined;
        this.cardType = null;
        this.existingCard = null;
        this.creditCard = {
            'billingAddress': this.createEmptyAddress(),
        };
        this.expirationMonth = null;
        this.expirationYear = null;
        this.ccForm.$setPristine();
    };
    PaymentCreditCardController.prototype.isNewCreditCardDisabled = function () {
        if (this.isNewCreditCard) {
            return true;
        }
        else {
            return false;
        }
    };
    PaymentCreditCardController.prototype.clearBillingAddress = function () {
        if (!this.isNewBillingAddress) {
            this.existingAddress = {};
            this.creditCard.billingAddress = this.createEmptyAddress();
        }
        else {
            return false;
        }
    };
    PaymentCreditCardController.prototype.createEmptyAddress = function () {
        return {
            'countryCode': 'US',
            'countryName': 'United States'
        };
    };
    PaymentCreditCardController.prototype.paymentBackToDelivery = function () {
        this.$state.go('paymentBackToDelivery');
    };
    PaymentCreditCardController.prototype.validateBillingAddress = function () {
        angular.element(document.getElementsByName(this.ccForm.firstName.$name)[0]).focus();
        angular.element(document.getElementsByName(this.ccForm.lastName.$name)[0]).focus();
    };
    PaymentCreditCardController.prototype.useSameAsShipping = function () {
        if (this.isSameAsShipping) {
            this.isNewBillingAddress = false;
            this.selectbillingAddressInfo = {
                name: this.CartService.cartData.shippingAddress.recipientName,
                address: "\n        " + this.CartService.cartData.shippingAddress.line1 + " " + (this.CartService.cartData.shippingAddress.line2 ? this.CartService.cartData.shippingAddress.line2 : '') + "<br>\n        " + this.CartService.cartData.shippingAddress.city + ", " + this.CartService.cartData.shippingAddress.regionCode + "\n        " + (this.CartService.cartData.shippingAddress.postalCode.length > 5 && this.CartService.cartData.shippingAddress.countryCode === 'US'
                    ? this.CartService.cartData.shippingAddress.postalCode.substr(0, 5) + '-' + this.CartService.cartData.shippingAddress.postalCode.substr(5)
                    : this.CartService.cartData.shippingAddress.postalCode) + ",\n           " + this.CartService.cartData.shippingAddress.countryName.toLowerCase() + "\n      "
            };
            this.creditCard.billingAddress = this.CartService.cartData.shippingAddress;
            this.creditCard.nameOnCard = this.creditCard.billingAddress.recipientName;
            this.isNameOnCardDisable = true;
            this.name = this.creditCard.billingAddress.recipientName.split(' ');
            if (this.name.length == 1) {
                this.creditCard.billingAddress.firstName = this.name[0];
                this.creditCard.billingAddress.lastName = this.name[0];
            }
            else if (this.name.length > 0) {
                for (var i = 0; i < this.name.length; i++) {
                    if (i == 0) {
                        this.creditCard.billingAddress.firstName = this.name[i];
                        this.creditCard.billingAddress.lastName = '';
                    }
                    else {
                        this.creditCard.billingAddress.lastName += this.name[i];
                    }
                }
            }
            this.existingBillingAddress = null;
        }
        else {
            this.selectbillingAddressInfo = '';
            this.existingBillingAddress = null;
            this.creditCard.billingAddress = null;
            this.creditCard.nameOnCard = null;
            this.isNameOnCardDisable = false;
        }
    };
    PaymentCreditCardController.prototype.clickReviewOrder = function () {
        var _this = this;
        var self = this;
        sessionStorage.setItem('expressCheckoutStatus', false);
        this._$rootScope.loading = true;
        this.disableRevieworder = true;
        this.CartService.creditCard = angular.copy(this.creditCard); //  convert model to JSON
        if (this.selectedPaymentType !== 'Credit Card') {
            var selectedPayment = {};
            this.CartService.addPayment(selectedPayment, this.selectedPaymentType, null)
                .then(function () {
                _this._$rootScope.loading = false;
                _this.disableRevieworder = false;
                _this.CartService.hideCVV(true);
                _this.$state.go('reviewOrder');
            })
                .catch(function () {
                _this.handleErrorMessage();
            });
        }
        else if (this.selectedPaymentType === 'Credit Card' && this.isNewCreditCard) {
            this.CartService.ccType = self.cardType.typeId;
            var creditCard = this.setCreditCardData();
            this.CreditCardService.addCreditCard(creditCard)
                .then(function (response) {
                var selectedPayment = response;
                self._$rootScope.localCVV = self.creditCard.verificationCode;
                self.CartService.addPayment(selectedPayment, 'CreditCard', null)
                    .then(function () {
                    self.disableRevieworder = false;
                    self._$rootScope.loading = false;
                    self.CartService.hideCVV(true);
                    self.$state.go('reviewOrder');
                })
                    .catch(function () {
                    self.handleErrorMessage();
                });
            });
        }
        else {
            this.creditCard.expirationDate = this.expirationYear + '/' + this.expirationMonth;
            if (self.creditCard.isDefaultPayment) {
                self.CreditCardService.setDefaultCreditCard(self.creditCard.creditCardId);
            }
            this._$rootScope.localCVV = this.creditCard.verificationCode;
            this.CartService.addPayment(this.creditCard, 'CreditCard', null)
                .then(function () {
                _this._$rootScope.loading = false;
                _this.disableRevieworder = false;
                _this.CartService.hideCVV(true);
                _this.$state.go('reviewOrder');
            })
                .catch(function () {
                _this.handleErrorMessage();
            });
        }
    };
    PaymentCreditCardController.prototype.handleErrorMessage = function () {
        this._$rootScope.loading = false;
        this.disableRevieworder = false;
        this.bannerMessage('An error has occurred while adding your payment method. Please try again.');
    };
    PaymentCreditCardController.prototype.setCreditCardData = function () {
        return {
            'cardNickName': this.creditCard.nameOnCard,
            'cardType': this.cardType && this.cardType.aresName ? this.cardType.aresName : '',
            'cardNumber': this.creditCard.cardNumber,
            'expirationDate': this.expirationYear + '/' + this.expirationMonth,
            'nameOnCard': this.creditCard.nameOnCard,
            'isDefaultPayment': this.creditCard.isDefaultPayment != undefined ? this.creditCard.isDefaultPayment : false,
            'addressId': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.addressId : undefined,
            'firstName': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.firstName : undefined,
            'lastName': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.lastName : undefined,
            'address1': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.line1 : undefined,
            'address2': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.line2 : undefined,
            'city': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.city : undefined,
            'state': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.regionCode : undefined,
            'countryCode': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.countryCode : undefined,
            'postalCode': this.creditCard.billingAddress != null ? this.creditCard.billingAddress.postalCode : undefined
        };
    };
    PaymentCreditCardController.prototype.isFormValid = function () {
        var isValid = false;
        if (this.selectedPaymentType === 'Credit Card') {
            if (this.isNewCreditCard) {
                if (this.ccForm.$valid &&
                    (this.cardType && this.cardType.typeName == this.validatorCardType) && !this.expiredCard) {
                    this.CartService.readyForReviewOrder = true;
                    isValid = true;
                }
            }
            else if ((this.creditCard.verificationCode || this.loggedInUser.isImpersonated) && !this.isCardExpired && this.ccForm.$valid) {
                this.CartService.readyForReviewOrder = true;
                isValid = true;
            }
        }
        else if (this.selectedPaymentType === 'Terms' ||
            this.selectedPaymentType === 'COD' ||
            this.selectedPaymentType === 'Prepaid') {
            this.CartService.readyForReviewOrder = true;
            isValid = true;
        }
        else {
            isValid = false;
        }
        // call output event for parent component
        this.onFormValidate({
            $event: {
                isValid: isValid,
                creditCard: this.setCreditCardData(),
                cardType: this.cardType || '',
                cvv: this.creditCard.verificationCode || '',
                isNewCreditCard: this.isNewCreditCard,
                paymentType: this.selectedPaymentType
            }
        });
        return isValid;
    };
    PaymentCreditCardController.prototype.reviewOrderDisabled = function () {
        // from the html:	 !$ctrl.isFormValid() ||($ctrl.selectedPaymentType === 'Credit Card' ?  ($ctrl.creditCard.billingAddress!=null && $ctrl.creditCard.billingAddress.firstName!=undefined && $ctrl.creditCard.billingAddress.firstName!=null ? false:true) :false) || $ctrl.disableRevieworder
        if (this.disableRevieworder)
            return true;
        if (!this.isFormValid())
            return true;
        if (this.selectedPaymentType != 'Credit Card')
            return false;
        if (!this.isNewCreditCard)
            return false;
        if (((this.creditCard.billingAddress || {}).firstName || '') == '')
            return true;
        if (((this.creditCard.billingAddress || {}).lastName || '') == '')
            return true;
        return false;
    };
    PaymentCreditCardController.prototype.getCreditCardName = function (creditCard) {
        if (creditCard) {
            if (creditCard.cardNickName) {
                return creditCard.cardNickName;
            }
            else {
                var creditCardType = this.CreditCardService.getCardType(creditCard.cardType);
                var maskedNumber = creditCardType === 'Amex' ? ' xxxx xxxxxx x' : ' xxxx xxxx xxxx ';
                return creditCardType + maskedNumber + creditCard.last4Digits;
            }
        }
    };
    // ES-4154 new function to map card's recipient name to billing address.
    PaymentCreditCardController.prototype.setRecipientName = function () {
        if (this.existingAddress && this.existingAddress.recipientName !== undefined && this.existingAddress.recipientName !== null) {
            return this.existingAddress.recipientName;
        }
        else {
            return 'Use Existing Address';
        }
    };
    PaymentCreditCardController.prototype.isAccountTypePractitionerWithDropShipAddress = function () {
        if (this.CartService.cartData == null || this.CartService.cartData.shippingAddress == null)
            return false;
        return this.loggedInUser.accountType === 'Practitioner' && this.CartService.cartData.shippingAddress.isDropShip;
    };
    return PaymentCreditCardController;
}());
export default PaymentCreditCardController;
//# sourceMappingURL=payment-credit-card.controller.js.map